import React from 'react';
import './style.scss'
import UserDetailTextField from "./Fields/UserDetailsTextField/UserDetailsTextField";
import UserDetailOptionsField from "./Fields/UserDetailsOptionsField/UserDetailsOptionsField";
import UserDetailDateField from "./Fields/UserDetailsDateField/UserDetailsDateField";


function UserDetailField(props) {
    function onFieldValueChange(newValue) {
        if (props.onFieldValueChange)
            props.onFieldValueChange(newValue);
    }

    function renderFieldByType() {
        switch (props.type) {
            case "text":
                return <UserDetailTextField displayName={props.displayName}
                                            value={props.value}
                                            isRequired={props.isRequired}
                                            isEditEnabled={props.isEditEnabled}
                                            isError={props.isError}
                                            onFieldValueChange={onFieldValueChange}/>;
            case "date":
                return <UserDetailDateField displayName={props.displayName}
                                            value={props.value}
                                            isRequired={props.isRequired}
                                            isEditEnabled={props.isEditEnabled}
                                            isError={props.isError}
                                            onFieldValueChange={onFieldValueChange}/>;
            case "options":
                return <UserDetailOptionsField displayName={props.displayName}
                                               value={props.value}
                                               options={props.options}
                                               isRequired={props.isRequired}
                                               isEditEnabled={props.isEditEnabled}
                                               isError={props.isError}
                                               onFieldValueChange={onFieldValueChange}/>;
        }
    }

    return (
        <tr className="field-row">
            <td className="field-name">{props.displayName}</td>
            <td className="field-value">
                {renderFieldByType()}
            </td>
        </tr>
    );
}

export default function UserDetails(props) {
    function onFieldValueChange(fieldName, newValue) {
        if (props.onFieldValueChange)
            props.onFieldValueChange(fieldName, newValue);
    }

    return (
        <table className="user-details-table">
            <tbody>
            {
                props.fields.map(field => (
                    (field.name in props.user &&
                        props.user[field.name] !== undefined &&
                        props.user[field.name] !== null &&
                        props.user[field.name] !== "") ||
                    props.isEditEnabled ?
                        <UserDetailField key={field.name}
                                         displayName={field.displayName}
                                         value={props.user[field.name]}
                                         type={field.type}
                                         options={field.options}
                                         isRequired={field.isRequired || false}
                                         isEditEnabled={props.isEditEnabled}
                                         isError={props.errorFields.has(field.name)}
                                         onFieldValueChange={(newValue) => onFieldValueChange(field.name, newValue)}
                        />
                        :
                        null
                ))
            }
            </tbody>
        </table>
    );
}